<div class="bond-form-page">
    <div class="btn-back-detail" (click)="cancel()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los abonos</span>
    </div>

    <div *ngIf="!loaded" class="loading-container">
        <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
    </div>

    <form *ngIf="loaded" [formGroup]="form" (ngSubmit)="save()" class="bond-form-content">

        <!-- Section 1: Tipo de Abono -->
        <div class="form-card">
            <div class="card-header">
                <i class="fal fa-layer-group card-icon"></i>
                <div>
                    <h2>Tipo de abono</h2>
                    <p class="card-subtitle">Selecciona cómo se estructura el abono</p>
                </div>
            </div>
            <div class="bond-type-cards">
                <div class="bond-type-card" [class.selected]="form.get('bond_type')?.value === 'fixed'"
                    (click)="setBondType('fixed')">
                    <div class="bond-type-icon">
                        <i class="fal fa-calendar-check"></i>
                    </div>
                    <h3>Eventos específicos</h3>
                    <p>Selecciona eventos cerrados que forman el abono. Ideal para temporadas completas o ciclos de teatro.</p>
                </div>
                <div class="bond-type-card" [class.selected]="form.get('bond_type')?.value === 'flexible'"
                    (click)="setBondType('flexible')">
                    <div class="bond-type-icon">
                        <i class="fal fa-layer-group"></i>
                    </div>
                    <h3>Pack flexible</h3>
                    <p>El usuario elige libremente un número mínimo de eventos de una lista para activar el descuento.</p>
                </div>
            </div>

            <!-- Precio y butaca única: solo en abonos de eventos específicos -->
            <ng-container *ngIf="form.get('bond_type')?.value === 'fixed'">
                <div class="pricing-mode-row">
                    <span class="channel-toggle-label">Precio del abono</span>
                    <div class="pricing-mode-options">
                        <div class="pricing-mode-option" [class.selected]="!isFixedPrices" (click)="setFixedPrice(false)">
                            <i class="fal fa-percent"></i>
                            <div>
                                <h4>% de descuento</h4>
                                <p>Un mismo porcentaje sobre el precio de cada entrada.</p>
                            </div>
                        </div>
                        <div class="pricing-mode-option" [class.selected]="isFixedPrices" (click)="setFixedPrice(true)">
                            <i class="fal fa-table-cells"></i>
                            <div>
                                <h4>Precio por evento y nivel</h4>
                                <p>Fijas el precio de cada función según la zona del mapa. Las zonas sin precio no entran.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between channel-toggle-row single-seat-row">
                    <div>
                        <span class="channel-toggle-label">Butaca única</span>
                        <span class="field-hint"><i class="fal fa-info-circle"></i> El comprador elige butaca una sola vez, en un único mapa, y se le asigna la misma en todos los eventos. {{ isFixedPrices ? 'Solo se ofrecen las zonas con precio en todas las funciones.' : 'Se cobra siempre la entrada general.' }}</span>
                    </div>
                    <mat-slide-toggle class="toggle-pink" formControlName="single_seat"></mat-slide-toggle>
                </div>
                <div class="single-seat-issues" *ngIf="getSingleSeatIssues().length > 0">
                    <p><i class="fal fa-triangle-exclamation"></i> Para ser de butaca única, todos los eventos tienen que usar mapa, estar en el mismo espacio y llevar una sola sesión:</p>
                    <ul>
                        <li *ngFor="let issue of getSingleSeatIssues()"><strong>{{ issue.title }}</strong> {{ issue.message }}.</li>
                    </ul>
                </div>
            </ng-container>
        </div>

        <!-- Section 2: Canal de venta -->
        <div class="form-card">
            <div class="card-header">
                <i class="fal fa-store card-icon"></i>
                <div>
                    <h2>¿Dónde se aplica?</h2>
                    <p class="card-subtitle">Elige en qué canales de venta estará disponible</p>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-between channel-toggle-row">
                <div>
                    <span class="channel-toggle-label">Todos los canales</span>
                    <span class="field-hint"><i class="fal fa-info-circle"></i> El abono se aplica en todos los canales de venta</span>
                </div>
                <mat-slide-toggle class="toggle-pink"
                    [checked]="allChannelsEnabled"
                    (change)="toggleAllChannels($event.checked)">
                </mat-slide-toggle>
            </div>
            <div class="bond-type-cards" *ngIf="!allChannelsEnabled">
                <div class="bond-type-card" [class.selected]="selectedWebChannel"
                    (click)="toggleWebChannel()">
                    <div class="bond-type-icon">
                        <i class="fal fa-globe"></i>
                    </div>
                    <h3>Web / App / Tótem</h3>
                    <p>El abono se vende por la web, app y tótem de autoservicio.</p>
                </div>
                <div class="bond-type-card" [class.selected]="selectedTaquilla"
                    (click)="toggleTaquilla()">
                    <div class="bond-type-icon">
                        <i class="fal fa-cash-register"></i>
                    </div>
                    <h3>Taquilla</h3>
                    <p>El abono se vende desde el TPV o datáfono.</p>
                </div>
            </div>
        </div>

        <!-- Section 3: Detalles de la Promoción -->
        <div class="form-card">
            <div class="card-header">
                <i class="fal fa-tag card-icon"></i>
                <div>
                    <h2>Detalles de la promoción</h2>
                    <p class="card-subtitle" *ngIf="!isFixedPrices">Nombre y valor del descuento que se aplicará</p>
                    <p class="card-subtitle" *ngIf="isFixedPrices">Nombre del abono · los precios se ponen más abajo, por evento y nivel</p>
                </div>
            </div>
            <div class="form-grid" [class.grid-3]="form.get('bond_type')?.value === 'flexible'">
                <div class="form-field">
                    <label class="field-label">NOMBRE DEL ABONO</label>
                    <input type="text" formControlName="name" placeholder="e.g., Abono Otoño 2024">
                </div>
                <div class="form-field" *ngIf="!isFixedPrices">
                    <label class="field-label">VALOR DEL DESCUENTO (%)</label>
                    <div class="input-with-suffix">
                        <input type="number" formControlName="discount_value" step="0.01" min="0" max="100" placeholder="20">
                        <span class="suffix">%</span>
                    </div>
                </div>
                <div class="form-field" *ngIf="form.get('bond_type')?.value === 'flexible'">
                    <label class="field-label">MÍNIMO DE EVENTOS A ELEGIR</label>
                    <input type="number" formControlName="min_events" min="1" placeholder="10">
                    <span class="field-hint"><i class="fal fa-info-circle"></i> El usuario debe elegir este número de eventos para poder conseguir el descuento.</span>
                </div>
            </div>
        </div>

        <!-- Section 3: Seleccionar Eventos -->
        <div class="form-card">
            <div class="card-header">
                <i class="fal fa-calendar card-icon"></i>
                <div>
                    <h2>Seleccionar eventos disponibles</h2>
                    <p class="card-subtitle">Elige los eventos y sesiones que forman parte de este abono</p>
                </div>
            </div>

            <div class="event-selector">
                <!-- Chips: una por sesión seleccionada -->
                <div class="event-chips" *ngIf="getSelectedEvents().length > 0">
                    <div class="event-chip" *ngFor="let pair of getSelectedEventSessionPairs(); trackBy: trackByPair">
                        <img [src]="urlImages + pair.event.image_url" [alt]="pair.event.title" class="event-chip-img" *ngIf="pair.event.image_url">
                        <span>
                            {{ pair.event.title }}
                            <span class="event-chip-session"> · {{ pair.session.start_date | date:'dd MMM':'+0000' }}<span *ngIf="getSessionDisplayTime(pair.session)"> · {{ getSessionDisplayTime(pair.session) }}</span></span>
                        </span>
                        <i class="fal fa-xmark" (click)="removeSessionChip(pair.session.id, pair.event.id)"></i>
                    </div>
                </div>

                <div class="event-list-wrapper">
                    <div class="event-filters-row">
                        <div class="event-search-input">
                            <i class="fal fa-search"></i>
                            <input type="text" placeholder="Buscar..." [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" (input)="onSearch()">
                        </div>
                        <div class="category-dropdown" (click)="categoryDropdownOpen = !categoryDropdownOpen">
                            <div class="category-dropdown-trigger">
                                <i class="fa-thin" [ngClass]="getSelectedCategoryIcon()"></i>
                                <span>{{ getSelectedCategoryName() }}</span>
                                <i class="fal fa-chevron-down dropdown-arrow" [class.open]="categoryDropdownOpen"></i>
                            </div>
                            <div class="category-dropdown-menu" *ngIf="categoryDropdownOpen" (click)="$event.stopPropagation()">
                                <div class="category-dropdown-item" [class.active]="eventCategoryFilter === null" (click)="selectCategory(null)">
                                    <i class="fa-thin fa-grid-2"></i>
                                    <span>Todas las categorías</span>
                                </div>
                                <div class="category-dropdown-item" *ngFor="let cat of eventCategories"
                                    [class.active]="eventCategoryFilter === cat.id"
                                    (click)="selectCategory(cat.id)">
                                    <i class="fa-thin {{ cat.icon }}"></i>
                                    <span>{{ cat.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="event-options-list">
                        <ng-container *ngFor="let event of getFilteredEvents(); trackBy: trackByEventId">
                            <label class="event-option"
                                [class.selected]="isEventSelected(event.id)"
                                (click)="toggleEvent(event.id)">
                                <i class="fa-solid fa-circle-check select-icon" *ngIf="isEventSelected(event.id)"></i>
                                <i class="fal fa-circle select-icon" *ngIf="!isEventSelected(event.id)"></i>
                                <img [src]="urlImages + event.image_url" [alt]="event.title" class="event-thumb" *ngIf="event.image_url">
                                <div class="event-thumb event-thumb--placeholder" *ngIf="!event.image_url">
                                    <i class="fal fa-image"></i>
                                </div>
                                <div class="event-option-info">
                                    <span class="event-option-title">{{ event.title }}</span>
                                    <div class="event-option-meta">
                                        <span *ngIf="getEventDateLabel(event)"><i class="fal fa-calendar"></i> {{ getEventDateLabel(event) }}</span>
                                        <span *ngIf="getEventDisplayTime(event)"><i class="fal fa-clock"></i> {{ getEventDisplayTime(event) }}</span>
                                        <span *ngIf="event.space?.name"><i class="fal fa-location-dot"></i> {{ event.space.name }}</span>
                                        <span *ngIf="!event.space?.name && event.address"><i class="fal fa-location-dot"></i> {{ event.address }}</span>
                                        <span *ngIf="event.category?.name" class="event-option-cat"><i class="fa-thin" [ngClass]="getCategoryIcon(event.category?.id)"></i> {{ event.category.name }}</span>
                                    </div>
                                </div>
                            </label>

                            <!-- Sub-selector de sesiones (cuando el evento está seleccionado) -->
                            <div class="event-sessions-dropdown"
                                *ngIf="isEventSelected(event.id) && getSessionsForEvent(event.id).length > 0">
                                <div class="event-sessions-list">
                                    <label class="event-session-option"
                                        *ngFor="let session of getSessionsForEvent(event.id)"
                                        [class.selected]="isSessionSelected(session.id)"
                                        (click)="toggleSession(session.id, event.id)">
                                        <i class="fa-solid fa-circle-check select-icon"
                                            *ngIf="isSessionSelected(session.id)"></i>
                                        <i class="fal fa-circle select-icon"
                                            *ngIf="!isSessionSelected(session.id)"></i>
                                        <div class="event-session-info">
                                            <span class="event-session-date">
                                                <i class="fal fa-calendar"></i>
                                                {{ session.start_date | date:'EEE dd MMM yyyy' }}
                                            </span>
                                            <span class="event-session-time" *ngIf="getSessionDisplayTime(session)">
                                                <i class="fal fa-clock"></i>
                                                {{ getSessionDisplayTime(session) }}
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </ng-container>
                        <p class="empty-state" *ngIf="getFilteredEvents().length === 0">
                            <i class="fal fa-calendar-xmark"></i>
                            No se encontraron eventos
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Precios por evento y nivel (solo en precio fijo) -->
        <div class="form-card" *ngIf="isFixedPrices">
            <div class="card-header">
                <i class="fal fa-table-cells card-icon"></i>
                <div>
                    <h2>Precios</h2>
                    <p class="card-subtitle">Precio de la entrada del abono en cada función según el nivel del mapa</p>
                </div>
            </div>

            <p class="empty-state" *ngIf="selectedEventIds.length === 0">
                <i class="fal fa-calendar"></i>
                Elige los eventos del abono para poner sus precios.
            </p>

            <div *ngIf="selectedEventIds.length > 0 && gridLoading && !passGrid" class="loading-container">
                <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}" containerClass="loading-box"></ng-lottie>
            </div>

            <p class="bottom-bar-error" *ngIf="gridError"><i class="fal fa-triangle-exclamation"></i> {{ gridError }}</p>

            <ng-container *ngIf="selectedEventIds.length > 0 && passGrid">
                <div class="price-fill-row">
                    <div class="input-with-suffix price-fill-input">
                        <input type="number" min="0" step="0.01" placeholder="Precio"
                            [(ngModel)]="bulkPrice" [ngModelOptions]="{standalone: true}">
                        <span class="suffix">€</span>
                    </div>
                    <button type="button" class="btn-fill" (click)="fillPrices()">
                        <i class="fal fa-fill-drip"></i> Rellenar todo
                    </button>
                    <span class="field-hint"><i class="fal fa-info-circle"></i> Con <i class="fal fa-arrow-down"></i> en una columna o <i class="fal fa-arrow-right"></i> en una función lo pones solo ahí. Deja vacía la zona que no entra en el abono.</span>
                </div>

                <div class="price-grid-wrapper" [class.is-reloading]="gridLoading">
                    <table class="price-grid">
                        <thead>
                            <tr>
                                <th class="price-grid-event">Función</th>
                                <th *ngFor="let column of passGrid.columns; trackBy: trackByColumnKey">
                                    <div class="price-grid-col-head">
                                        <span>{{ column.name }}</span>
                                        <button type="button" class="btn-fill-icon" title="Poner el precio en toda la columna"
                                            (click)="fillPrices({ columnKey: column.key })">
                                            <i class="fal fa-arrow-down"></i>
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of passGrid.rows; trackBy: trackByGridRow">
                                <td class="price-grid-event">
                                    <div class="price-grid-row-head">
                                        <div>
                                            <span class="price-grid-title">{{ row.title }}</span>
                                            <span class="price-grid-date" *ngIf="row.start_date">{{ row.start_date | date:'dd MMM yyyy · HH:mm':'+0000' }}</span>
                                        </div>
                                        <button type="button" class="btn-fill-icon" title="Poner el precio en toda la función"
                                            (click)="fillPrices({ sessionId: row.session_id })">
                                            <i class="fal fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </td>
                                <td *ngFor="let column of passGrid.columns; trackBy: trackByColumnKey"
                                    [class.cell-missing]="!getGridCell(row, column.key)">
                                    <ng-container *ngIf="getGridCell(row, column.key)">
                                        <div class="price-cell">
                                            <div class="input-with-suffix">
                                                <input type="number" min="0" step="0.01" placeholder="—"
                                                    [ngModel]="priceCells[row.session_id]?.[column.key]"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="setCellPrice(row.session_id, column.key, $event)">
                                                <span class="suffix">€</span>
                                            </div>
                                            <span class="price-cell-hint" *ngIf="priceCells[row.session_id]?.[column.key] == null">No entra</span>
                                        </div>
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td class="price-grid-event"><span class="price-grid-title">Abono completo</span></td>
                                <td *ngFor="let column of passGrid.columns; trackBy: trackByColumnKey">
                                    <span class="price-total" *ngIf="getColumnTotal(column.key) != null; else noTotal">{{ getColumnTotal(column.key) | number:'1.2-2':'es' }} €</span>
                                    <ng-template #noTotal><span class="price-cell-none" title="Esta zona no entra en alguna función">—</span></ng-template>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <p class="field-hint price-from" *ngIf="getFromTotal() != null">
                    <i class="fal fa-tag"></i> En los escaparates se verá «desde {{ getFromTotal() | number:'1.2-2':'es' }} €» (la zona más barata de cada función). Cada comprador puede elegir una zona distinta en cada función.
                </p>

                <div class="single-seat-issues" *ngIf="getPriceIssues().length > 0 && !gridLoading">
                    <p><i class="fal fa-triangle-exclamation"></i> Antes de guardar:</p>
                    <ul>
                        <li *ngFor="let issue of getPriceIssues()">{{ issue }}</li>
                    </ul>
                </div>
            </ng-container>
        </div>

        <!-- Section 5: Período de venta -->
        <div class="form-card">
            <div class="card-header">
                <i class="fal fa-calendar-range card-icon"></i>
                <div>
                    <h2>¿Cuándo se puede comprar?</h2>
                    <p class="card-subtitle">Opcional · Define el periodo en el que se puede adquirir el abono</p>
                </div>
            </div>
            <div class="form-grid-2">
                <div class="form-field">
                    <label class="field-label">FECHA INICIO VALIDEZ</label>
                    <app-datetime-selector
                        [date]="startsAtDate"
                        [time]="startsAtTime"
                        placeholder="Fecha inicio validez"
                        (saveDate)="onStartsAtChange($event)">
                    </app-datetime-selector>
                </div>
                <div class="form-field">
                    <label class="field-label">FECHA FIN VALIDEZ</label>
                    <app-datetime-selector
                        [date]="endsAtDate"
                        [time]="endsAtTime"
                        placeholder="Fecha fin validez"
                        (saveDate)="onEndsAtChange($event)">
                    </app-datetime-selector>
                </div>
            </div>
            <p class="field-hint" style="margin-top: 8px;"><i class="fal fa-info-circle"></i> Si no defines fechas, el abono estará disponible de forma indefinida. Si defines inicio, aparecerá como «Próximamente» hasta esa fecha.</p>
        </div>

    </form>

    <!-- Bottom bar -->
    <div class="bottom-bar" *ngIf="loaded">
        <div class="bottom-bar-info bottom-bar-error" *ngIf="saveError">
            <i class="fal fa-triangle-exclamation"></i>
            <span>{{ saveError }}</span>
        </div>
        <div class="bottom-bar-info" *ngIf="!saveError">
            <i class="fal fa-info-circle"></i>
            <span *ngIf="getSelectedEvents().length === 0">Selecciona los eventos que formarán parte del abono.</span>
            <span *ngIf="getSelectedEvents().length > 0">{{ getSelectedEvents().length }} evento{{ getSelectedEvents().length !== 1 ? 's' : '' }} seleccionado{{ getSelectedEvents().length !== 1 ? 's' : '' }}.</span>
        </div>
        <div class="bottom-bar-actions">
            <button type="button" class="btn-discard" (click)="cancel()">Descartar cambios</button>
            <button type="button" class="btn-save" (click)="save()" [disabled]="form.invalid || saving || getSelectedEvents().length === 0 || getSingleSeatIssues().length > 0 || getPriceIssues().length > 0">
                <i class="fal" [ngClass]="saving ? 'fa-spinner-third fa-spin' : 'fa-floppy-disk'"></i>
                {{ saving ? 'Guardando...' : (isEdit ? 'Guardar abono' : 'Crear abono') }}
            </button>
        </div>
    </div>
</div>
